<template>
    <div class="user-index action-table">
        <v-server-table :url="route('tenantapi.users.index')" :columns="columns" :options="options" ref="table">
            <user-table-cls-column
                    slot="cls_column"
                    slot-scope="props"
                    :data="props.row">
            </user-table-cls-column>

           <user-table-actions
                slot="actions"
                slot-scope="props"
                :data="props.row"
                :index="props.index"
                :deleted-only="showDeletedUsersOnly"
            ></user-table-actions>
        </v-server-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
import userTableOptions from './partials/userTableOptions'

export default {
    data() {
        return {
            filterByClient: null,
            filterByRole: null,
            hideSubclientUsers: false,
            showDeletedUsersOnly: false,
            columns: ['cls_column', 'name', 'client', 'actions'],
            options: userTableOptions
        };
    },
    mounted() {
        EventBus.$on('databaseChanged', () => {
            this.$refs.table.refresh();
        });

        EventBus.$on('onDelete', deleteId => {
            this.$refs.table.refresh();
        });

        EventBus.$on('onToggleUser', deleteId => {
            this.$refs.table.refresh();
        });

        EventBus.$on('onRestoreUser', index => this.$refs.table.refresh());

        EventBus.$on('onFilter', query => {
            this.$refs.table.setFilter(query);
        });

        EventBus.$on('filterChanged', filters => {
            this.filterByClient = filters.filterByClient;
            this.filterByRole = filters.filterByRole;
            this.hideSubclientUsers = filters.hideSubclientUsers;
            this.showDeletedUsersOnly = filters.showDeletedUsersOnly;
            this.$refs.table.refresh();
        });
    }
};
</script>
